import React, { useCallback } from 'react';
import { FieldElementPropTypes } from '../propTypes';
import { Slider } from '../../slider';

const SliderField = ({
  field: { id, label, mode, options, ...props },
  ctx: { values, setFieldValue, classes, setFieldTouched }
}) => {
  const onUpdate = useCallback(
    (op) => {
      setFieldValue(id, op);
      setFieldTouched(id, true, false);
    },
    [id, setFieldTouched, setFieldValue]
  );
  return (
    <Slider
      key={id}
      id={id}
      name={id}
      label={label}
      value={values[id]}
      options={options}
      mode={mode}
      classes={classes[id]}
      onUpdate={onUpdate}
      {...props}
    />
  );
};

SliderField.propTypes = FieldElementPropTypes;
export default SliderField;
